module.exports = __webpack_public_path__ + "img/gamesdk21.708f4fe.png";